(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const switcher = document.querySelector('.tx-powermail-language-switcher');
    const buttons = switcher.querySelectorAll('button');

    const localState = localStorage.getItem('tx_powermail_language_switcher_state') ?? "";

    const saveState = function(state) {
      localStorage.setItem('tx_powermail_language_switcher_state', state);
    }

    const switchState = function(state) {

      const container = switcher.closest('.tx-powermail');
      buttons.forEach(function(button) {
        button.classList.remove('button-primary');
        button.classList.add('button-secondary');
      });

      if (state === "") {
        let btn = switcher.querySelector('button[data-language]');
        btn.classList.remove('button-secondary');
        btn.classList.add('button-primary');
        container.classList.remove('show-translated');
        saveState("");
      }
      if (state === "alt") {
        let btn = switcher.querySelector('button[data-alt-language]');
        btn.classList.remove('button-secondary');
        btn.classList.add('button-primary');
        container.classList.add('show-translated');
        saveState("alt")
      }

      container.querySelectorAll('select').forEach(function(select) {
        const options = JSON.parse(select.dataset['options'] ?? '');
        if (Array.isArray(options)) {
          options.forEach(function(option) {
            const optionElement = select.querySelector(`option[value="${option.value}"]`);
            if (optionElement) {
              let text = optionElement.textContent;
              if (state === "") {
                text = option.label;
              }
              if (state === "alt" && option.labelAltLanguage) {
                text = option.labelAltLanguage;
              }
              optionElement.textContent = text;
            }
          });
        }
      });
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        const languageAlt = this.getAttribute('data-alt-language');
        switchState(languageAlt ? "alt" : "");
      });
    });

    switchState(localState);
  });
})();
